import {
  FaBox,
  FaBoxOpen,
  FaBolt,
  FaChartBar,
  FaChartLine,
  FaChartPie,
  FaRegImage,
  FaTable,
  FaTachometerAlt,
  FaTerminal,
  FaTextHeight,
  FaThermometerHalf,
} from "react-icons/fa";
import { GiChemicalTank } from "react-icons/gi";
import { IoIosListBox, IoMdNotificationsOutline } from "react-icons/io";
import { MdOutlineHeatPump } from "react-icons/md";
import { TbChartHistogram, TbFileTypeHtml } from "react-icons/tb";

export const componentsOptions = [
  {
    value: "bar",
    label: "Bar Graph",
    icon: <FaChartBar />,
    subtitle: "Display a Bar Chart",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "axis", "timeFrame"],
  },
  {
    value: "comboBar",
    label: "Combo Bar / Line Chart Graph",
    icon: <TbChartHistogram />,
    subtitle: "Display Bar And Line Combo Chart",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "axis", "timeFrame"],
  },
  {
    value: "line",
    label: "Line Graph",
    icon: <FaChartLine />,
    subtitle: "Display a Line Chart",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "axis", "timeFrame"],
  },
  {
    value: "pie",
    label: "Pie Graph",
    icon: <FaChartPie />,
    subtitle: "Display a Pie Chart",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "tank",
    label: "3D Fuel Tank",
    icon: <GiChemicalTank />,
    subtitle: "Display a 3D Fuel Tank",
    minHeight: 250,
    tabs: ["basic", "data", "gauge", "timeFrame"],
  },
  {
    value: "counter",
    label: "Counter",
    icon: <IoIosListBox />,
    subtitle: "Display a Counter",
    minHeight: 100,
    tabs: ["basic", "counter", "data", "appearance", "timeFrame"],
  },
  {
    value: "splitCounter",
    label: "Split Counter",
    icon: <FaBox />,
    subtitle: "Display a Split Counter",
    minHeight: 125,
    tabs: ["basic", "counter", "data", "appearance", "timeFrame"],
  },
  {
    value: "dial",
    label: "Dial",
    icon: <FaTachometerAlt />,
    subtitle: "Display a Dial",
    minHeight: 330,
    tabs: ["basic", "data", "gauge", "appearance", "timeFrame"],
  },
  {
    value: "table",
    label: "Table",
    icon: <FaTable />,
    subtitle: "Display a Table",
    minHeight: 350,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "dynamicBox",
    label: "Dynamic Box",
    icon: <FaBoxOpen />,
    subtitle: "Display a Dynamic Box",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "loadSummary",
    label: "Summary Card",
    icon: <FaBolt />,
    subtitle: "Display Load, Peak Demand & Efficiency",
    minHeight: 230,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "thermometer",
    label: "Thermometer Gauges",
    icon: <FaThermometerHalf />,
    subtitle: "Display Thermometer Gauges",
    minHeight: 250,
    tabs: ["basic", "data", "gauge", "timeFrame"],
  },
  {
    value: "textBox",
    label: "Text Box",
    icon: <FaTextHeight />,
    subtitle: "Display a Text Box",
    minHeight: 150,
    tabs: ["basic", "appearance", "editor"],
  },
  {
    value: "html",
    label: "Custom HTML",
    icon: <TbFileTypeHtml />,
    subtitle: "Display Custom HTML",
    minHeight: 250,
    tabs: ["basic", "appearance", "editor"],
  },
  {
    value: "image",
    label: "Image",
    icon: <FaRegImage />,
    subtitle: "Display an Image",
    minHeight: 250,
    tabs: ["basic", "appearance"],
  },
  {
    value: "alarmNotification",
    label: "Alarm Notification",
    icon: <IoMdNotificationsOutline />,
    subtitle: "Display Device Offline & Alarm Notifications",
    minHeight: 250,
    tabs: ["basic", "data"],
  },
  {
    value: "iframe",
    label: "Iframe",
    icon: <FaTerminal />,
    subtitle: "Display an Iframe",
    minHeight: 250,
    tabs: ["basic"],
  },
];

//! icons need to change for live components
export const liveComponentsOptions = [
  {
    value: "pumps",
    label: "Pumps",
    icon: <MdOutlineHeatPump />,
    subtitle: "Live Pumps Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "conveyer",
    label: "Conveyer",
    icon: <FaBoxOpen />,
    subtitle: "Live Conveyer Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "motor",
    label: "Motor",
    icon: <FaTachometerAlt />,
    subtitle: "Live Motor Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "tanks",
    label: "Tanks",
    icon: <GiChemicalTank />,
    subtitle: "Live Tanks Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "chiller",
    label: "Chiller",
    icon: <FaThermometerHalf />,
    subtitle: "Live Chiller Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "ahu",
    label: "AHU",
    icon: <FaBox />,
    subtitle: "Live AHU Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "blowerFan",
    label: "Blower/Fan",
    icon: <FaTachometerAlt />,
    subtitle: "Live Blower/Fan Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "battery",
    label: "Battery",
    icon: <FaBox />,
    subtitle: "Live Battery Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "msb",
    label: "MSB",
    icon: <FaBoxOpen />,
    subtitle: "Live MSB Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "transformer",
    label: "Transformer",
    icon: <FaBox />,
    subtitle: "Live Transformer Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "switchgear",
    label: "Switchgear",
    icon: <FaTerminal />,
    subtitle: "Live Switchgear Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "splitACIndoor",
    label: "Split A/C (indoor)",
    icon: <FaThermometerHalf />,
    subtitle: "Live Split A/C (indoor) Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "highbayLamp",
    label: "Highbay Lamp",
    icon: <FaBox />,
    subtitle: "Live Highbay Lamp Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "solarPanel",
    label: "Solar Panel",
    icon: <FaRegImage />,
    subtitle: "Live Solar Panel Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
  {
    value: "solarInverter",
    label: "Solar Inverter",
    icon: <FaBox />,
    subtitle: "Live Solar Inverter Component",
    minHeight: 250,
    tabs: ["basic", "data", "appearance", "timeFrame"],
  },
];
export const modalTabs = {
  basic: {
    key: "basic",
    label: "Basic",
  },
  data: {
    key: "data",
    label: "Data",
  },
  appearance: {
    key: "appearance",
    label: "Appearance",
  },
  axis: {
    key: "axis",
    label: "Axis",
  },
  timeFrame: {
    key: "timeFrame",
    label: "Time Frame",
  },
  gauge: {
    key: "gauge",
    label: "Gauge",
  },
  counter: {
    key: "counter",
    label: "Counter",
  },
  editor: {
    key: "editor",
    label: "Editor",
  },
};

export const getModalTabs = (component) => {
  const arr = component?.tabs?.map((tabKey) => modalTabs[tabKey]) || [];
  return arr;
};
